// extracted by mini-css-extract-plugin
export default {"icon":"reviewIcon_icon__omoTd","disabled":"reviewIcon_disabled__1EgH1"};